import React from "react";
import styled from "@emotion/styled";
import { Checkmark } from "./Checkmark";
import { compassColors } from "@utils/styling";

const Container = styled.div<{ checked: boolean; hasError: boolean }>`
  background-color: ${compassColors.white};
  border: 1px solid ${compassColors.sand2};
  border-radius: 4px;
  box-sizing: border-box;
  height: 24px;
  width: 24px;
  margin-right: 16px;
  flex-shrink: 0;

  ${(props) =>
    props.checked ? `border: 1px solid ${compassColors.lagoon}` : ""}

  ${(props) =>
    props.hasError ? `border: 1px solid ${compassColors.cinnamon}` : ""}
`;

type Props = {
  checked?: boolean;
  hasError?: boolean;
};

export default function Checkbox({ checked, hasError }: Props) {
  return (
    <Container checked={checked} hasError={hasError}>
      <Checkmark checked={checked} />
    </Container>
  );
}
